import produce from 'immer';

// Import action types
import * as productTypes from '@redux/actions/product/productTypes';

const initState = {
  freeGifts: {},
  isLoading: false,
  error: ''
};

const freeGiftReducer = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
    case productTypes.GET_FREE_GIFT:
      draft.isLoading = true;
      break;

    case productTypes.GET_FREE_GIFT_SUCCESS:
      draft.isLoading = false;

      draft.freeGifts  =action.payload;
      break;

    case productTypes.GET_FREE_GIFT_FAILED:
      draft.isLoading = false;

      draft.error = action.error;
    }

    return draft;
  });

export default freeGiftReducer;